import React from 'react';
import Question from '../Components/Question';

function UnaffectedBreastCancer() {
    return Question({
        question: (<>Which type(s) of cancer are present in the family history?</>),
        answers: [
            {
                link: "/unaffected/breast/exclusive",
                text: (<>Breast Cancer only</>),
                properties: {
                    color: 'pink'
                }
            },
            {
                link: "/unaffected/breast/breast-and-ovarian",
                text: (<>Breast and Ovarian Cancer</>),
                properties: {
                    color: 'purple'
                }
            }
        ]
    });
}

export default UnaffectedBreastCancer;
